import React from "react";
import App from "./../app.jsx";
import { Navigate, useRoutes } from "react-router-dom";

import Dashboard from "./../pages/dashboard/dashboard.js";
import JumpDetection from "./../page/JumpDetection.js";
import UiBootstrap from "./../pages/ui/bootstrap.js";
import UiButtons from "./../pages/ui/buttons.js";
import UiCard from "./../pages/ui/card.js";
import UiIcons from "./../pages/ui/icons.js";
import UiModalNotifications from "./../pages/ui/modal-notifications.js";
import UiTypography from "./../pages/ui/typography.js";
import UiTabsAccordions from "./../pages/ui/tabs-accordions.js";
import FormElements from "./../pages/form/elements.js";
import FormPlugins from "./../pages/form/plugins.js";
import FormWizards from "./../pages/form/wizards.js";
import TableElements from "./../pages/table/elements.js";
import TablePlugins from "./../pages/table/plugins.js";
import LayoutStarter from "./../pages/layout/starter.js";
import LayoutFixedFooter from "./../pages/layout/fixed-footer.js";
import LayoutFullHeight from "./../pages/layout/full-height.js";
import LayoutFullWidth from "./../pages/layout/full-width.js";
import LayoutBoxedLayout from "./../pages/layout/boxed-layout.js";
import LayoutCollapsedSidebar from "./../pages/layout/collapsed-sidebar.js";
import LayoutTopNav from "./../pages/layout/top-nav.js";
import LayoutMixedNav from "./../pages/layout/mixed-nav.js";
import LayoutMixedNavBoxedLayout from "./../pages/layout/mixed-nav-boxed-layout.js";
import PagesScrumBoard from "./../pages/pages/scrum-board.js";
import PagesProducts from "./../pages/pages/products.js";
import PagesProductDetails from "./../pages/pages/product-details.js";
import PagesOrders from "./../pages/pages/orders.js";
import PagesOrderDetails from "./../pages/pages/order-details.js";
import PagesGallery from "./../pages/pages/gallery.js";
import PagesSearchResults from "./../pages/pages/search-results.js";
import PagesComingSoon from "./../pages/pages/coming-soon.js";
import PagesError from "./../pages/pages/error.js";
import PagesLogin from "../pages/pages/NewLogin.jsx";
import PagesRegister from "./../pages/pages/register.js";
import PagesMessenger from "./../pages/pages/messenger.js";
import PagesDataManagement from "./../pages/pages/data-management.js";
import Profile from "./../pages/profile/profile.js";
import Settings from "./../pages/settings/settings.js";
import Helper from "./../pages/helper/helper.js";
import LeanDetection from "../page/LeanDetection.js";
import PeopleDetection from "../page/PeopleDetection.js";
import VideoRecorded from "../page/VideoRecorded.js";
import SummaryJPO from "../page/SummaryJPO.js";
import HRISBPO from "../page/HRISBPO.js";
import Lokasi from "../page/Lokasi.js";
import CCTV from "../page/CCTVLive.js";
import UserManagment from "../page/UserManagment.js";
import Camera from "../page/Camera.jsx";
import Role from "../page/Role.jsx";
import Analytic from "../page/Analytic.jsx";
import Units from "../page/Units.jsx";
import Sensor from "../page/Sensor.jsx";
import Device from "../page/Device.jsx";
import Sites from "../page/Sites.jsx";
import LiveDetectionJump from "../page/LiveDetectionJump.js";
import LiveDetectionLean from "../page/LiveDetectionLean.js";
import LivePeopleDetection from "../page/LivePeopleDetection.js";
import { useSelector } from "react-redux";
import RoleModule from "../page/RoleModule.jsx";

const AppRoute = () => {
  const { isLoggedIn } = useSelector((state) => state.auth);
  const routes = useRoutes([
    {
      path: "/",
      element: <App />,
      children: [
        { path: "", element: <Navigate to="/dashboard" /> },
        { path: "dashboard", element: <Dashboard /> },
        { path: "laporan/laporan-pendeteksi-orang-bersandar", element: <LeanDetection /> },
        { path: "laporan/laporan-jumlah-orang", element: <PeopleDetection /> },
        { path: "laporan/laporan-pendeteksi-orang-berpotensi-melompat", element: <JumpDetection /> },
        { path: "summaryJPO/:siteId", element: <SummaryJPO /> },
        { path: "video-recorded", element: <VideoRecorded /> },
        { path: "deteksi-langsung", element: <HRISBPO /> },
        { path: "deteksi-langsung/pendeteksi-orang-berpotensi-melompat/:pages", element: <LiveDetectionJump /> },
        { path: "deteksi-langsung/pendeteksi-orang-bersandar/:pages", element: <LiveDetectionLean /> },
        { path: "deteksi-langsung/pendeteksi-perhitungan-orang", element: <LivePeopleDetection /> },
        { path: "lokasi-jpo", element: <Lokasi /> },    
        { path: "cctv-live", element: <CCTV /> }, 
        { path: "manajemen-pengguna/daftar-pengguna", element: <UserManagment /> },
        { path: "manajemen-pengguna/daftar-peran", element: <Role /> },
        { path: "manajemen-pengguna/modul", element: <RoleModule /> },
        { path: "master-data/site", element: <Sites /> },
        { path: "master-data/kamera", element: <Camera /> },
        { path: "master-data/analytic", element: <Analytic /> },
        { path: "master-data/unit", element: <Units /> }, 
        { path: "master-data/device", element: <Device /> },
        { path: "master-data/sensor", element: <Sensor /> },

        { path: "profile", element: <Profile /> },
        { path: "settings", element: <Settings /> },
        { path: "helper", element: <Helper /> },
      ],
    },

    { path: "login", element: <PagesLogin /> },
  ]);
  return routes;
};

export default AppRoute;
